import QueryString from "qs"
import http from "../index"
import {
    apiListUser,
    apiCreateUser,
    apiLock,
    apiUnlock,
    apidropdownlistCustomers,
    apiGetUser,
    // apiUpdateUser,
    apiCreateUserLeader,
    apiExport,
    apiListUserLeader,
    apiListLeaderUser,
    apiLeaderLock,
    apiLeaderUnlock
} from "./urls"

const CreateUser = body => http.post(apiCreateUser, body)
const ListUser = params => http.get(apiListUser, { params }) 
const listGetUser = params => http.get(apiGetUser, { params })
const UpdateUser = (id, params) => http.post(`/1.0/user/${id}/update`, params);
const LockUser = (params) => http.put(apiLock, params)
const UnlockUser = (params) => http.put(apiUnlock, params)
const detailUser = (id) => http.get(`/1.0/user/${id}/detail`);
const dropdownlistCustomers = params => http.get(apidropdownlistCustomers, { params })
const listLeaderUser = (params) => http.get(apiListLeaderUser,{params});

const createUserLeader = body => http.post(apiCreateUserLeader, body)
const exportData = (params) => http.get(apiExport, {responseType: "blob",params: params });
const listUserLeader = (params) => http.get(apiListUserLeader,{params});
const updateUserLeader = (id, params) => http.post(`1.0/wsm/leader/user/${id}/update`, params);
const detailUserLeader = (id) => http.get(`1.0/wsm/leader/user/${id}/detail`);
const leaderLockUser = (params) => http.put(apiLeaderLock, params)
const leaderUnlockUser = (params) => http.put(apiLeaderUnlock, params)
const UserManagement = {
    CreateUser,
    ListUser,
    UpdateUser,
    LockUser,
    UnlockUser,
    detailUser,
    dropdownlistCustomers,
    listGetUser,
    createUserLeader,
    exportData,
    listUserLeader,
    updateUserLeader,
    detailUserLeader,
    listLeaderUser,
    leaderLockUser,
    leaderUnlockUser
}
export default UserManagement